import { createColumnHelper } from '@tanstack/react-table';

import { ColumnType } from '@/components/PatientDataTable';

import { StudyProgressObject } from '../types';

import { columns } from '.';

const columnHelper = createColumnHelper<StudyProgressObject>();

export const studyTabColumns: ColumnType = [
	columnHelper.accessor('group_name', {
		header: () => 'Study',
	}),
	...columns,
];

export const cohortSubgroupTabColumns: ColumnType = [
	columnHelper.accessor('group_name', {
		header: () => 'Cohort subgroup',
	}),
	...columns,
];

export const assignedTrialSiteTabColumns: ColumnType = [
	columnHelper.accessor('group_name', {
		header: () => 'Assigned Trial Site',
	}),
	...columns,
];

export const genderTabColumns: ColumnType = [
	columnHelper.accessor('group_name', {
		header: () => 'Gender',
	}),
	...columns,
];

export const careOrgTabColumns: ColumnType = [
	columnHelper.accessor('group_name', {
		header: () => 'Care Organisation',
	}),
	...columns,
];

export const letterSentTabColumns: ColumnType = [
	columnHelper.accessor('group_name', {
		header: () => 'Letter Sent',
	}),
	...columns,
];
